import { render, staticRenderFns } from "./invoiceSetting.vue?vue&type=template&id=48ea4f33&scoped=true"
import script from "./invoiceSetting.vue?vue&type=script&lang=js"
export * from "./invoiceSetting.vue?vue&type=script&lang=js"
import style0 from "./invoiceSetting.vue?vue&type=style&index=0&id=48ea4f33&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ea4f33",
  null
  
)

export default component.exports